
import Vue from 'vue'
import { kebabCase, random, isString } from 'lodash'

export type TabId = string | number

export interface ITab {
  id: TabId
  label: string
  disabled: boolean
  hidden: boolean
}

export type TabType = string | Partial<ITab>

export default Vue.extend({
  props: {
    items: {
      type: [Array as () => TabType[]],
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },

  computed: {
    tabsArray(): ITab[] {
      return this.normalizeTabs(this.items)
    }
  },

  created() {

  },

  methods: {
    normalizeTabs(data: TabType[]): ITab[] {
      return data.map((item) => {
        if (isString(item)) {
          item = { label: item } as Partial<ITab>
        }

        return {
          id: item.id || item.label ? kebabCase(item.label) : random(0, 100),
          label: item.label || item.id || 'Unknown',
          disabled: item.disabled || false,
          hidden: item.hidden || false
        } as ITab
      })
    },

    stringArrayToTabs(data: string[]): ITab[] {
      return this.normalizeTabs(data.map(label => ({ label })))
    },

    getClass(item: ITab) {
      return {
        'item--active': this.value === item.id,
        'item--hidden': item.hidden,
        'item--disabled': item.disabled
      }
    },

    select(value: TabId) {
      this.$emit('input', value)
    }
  }
})
